
import request from './request';
import { getRefreshToken,getToken,setToken,setRefreshToken,removeToken,removeRefreshToken } from './token';

let refreshPromise = null;
let lastEmptyWarnTime = 0; // 频率限制：防止短时间内重复输出"刷新令牌为空"

export async function refreshToken() {
  if (refreshPromise) {
    return refreshPromise;
  }

  refreshPromise = new Promise(async (resolve, reject) => {
    try {
      const refreshTokenValue = getRefreshToken();
      if (!refreshTokenValue) {
        // resolve(false) 而非 reject：令牌为空是预期的状态异常，
        // 应走正常的跳转登录流程，而非抛出错误日志
        const now = Date.now();
        if (now - lastEmptyWarnTime > 5000) {
          console.warn('刷新令牌为空，跳转登录');
          lastEmptyWarnTime = now;
        }
        resolve(false);
        return;
      }

      const resp = await request.post('/api/auth/refreshtoken', {
        token: getToken(),
        refreshToken: refreshTokenValue,
        __isRefreshToken: true,
      });

      if (resp.code === 200 && resp.data.success) {
        const newAccessToken = resp.data.token?.accessToken;
        const newRefreshToken = resp.data.token?.refreshToken;
        // 先校验新令牌有效，再删除旧令牌，防止旧令牌被删后新令牌无效导致永久丢失
        if (newAccessToken && newRefreshToken) {
          removeToken();
          removeRefreshToken();
          setToken(newAccessToken);
          setRefreshToken(newRefreshToken);
          resolve(true);
        } else {
          console.warn('刷新接口返回的 token 字段缺失，保留旧令牌');
          resolve(false);
        }
      } else {
        resolve(false);
      }
    } catch (error) {
      reject(error);
    } finally {
      refreshPromise = null;
    }
  });

  return refreshPromise;
}

export function isRefreshToken(config) {
  return !!config.__isRefreshToken;
}

// 获取正在进行的刷新 Promise，供其他模块等待
export function getRefreshPromise() {
  return refreshPromise;
}
